module.exports = __webpack_public_path__ + "static/img/010.8bdf945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/010.png
// module id = H+Pw
// module chunks = 0